import { gql } from "@/gql";
import "./invitation-data-fragment";

export const TEAM_MEMBERS_QUERY = gql(`
  query TeamMembers($salonId: ID!, $filters: TeamMemberFilterInput) {
    teamMembers(salonId: $salonId, filters: $filters) {
      members {
        id
        workerId
        salonId
        franchiseId
        role
        color
        isActive
        canAcceptOnlineBookings
        serviceRestrictionMode
        allowedServices {
          id
          name
        }
        allowedCategories {
          id
          name
        }
        createdAt
        updatedAt
        worker {
          id
          userId
          displayName
          bio
          profileImageUrl
          user {
            id
            email
            firstName
            lastName
            role
            isActive
            emailVerified
          }
          invitations {
            ...InvitationData @unmask
          }
        }
      }
      pagination {
        total
        page
        limit
        totalPages
        hasNext
        hasPrevious
      }
    }
  }
`);
